import script from "./StockDate.vue?vue&type=script&setup=true&lang=js"
export * from "./StockDate.vue?vue&type=script&setup=true&lang=js"

import "./StockDate.vue?vue&type=style&index=0&id=4c8f1570&lang=css"

const __exports__ = script;

export default __exports__